import { skipToken, useQuery } from '@apollo/client/react';
import { ExpressLoanDocument } from 'graphql/generated/graphql';

const useExpressLoan = ({ id }: { id?: string | null }) => {
  const { loading, error, data } = useQuery(
    ExpressLoanDocument,
    // Skipped without an id.
    id ? { variables: { id }, fetchPolicy: 'cache-and-network' } : skipToken,
  );
  return { loading, error, expressLoan: data?.expressLoan };
};

export default useExpressLoan;
